import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';

@Component({
  selector: 'app-system-log-view',
  templateUrl: './system-log-view.component.html',
  styleUrls: ['./system-log-view.component.scss']
})
export class SystemLogViewComponent implements OnInit {
  log_id: number;
  all_router_details: string;

  constructor(private route: ActivatedRoute, private router: Router, public gfunc: GlobalFunctionsService,) { 
            // need to add this as routes does not work globally
            this.all_router_details = this.router.url;
            this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
           
           this.log_id = +this.route.snapshot.paramMap.get('log_id');
  }

  ngOnInit(): void {
  }

}
